import React, { use, useEffect, useRef } from 'react';
import L from 'leaflet';
import AvatarOverlay from '../AvatarOverlay';
import { useSelector, useDispatch } from 'react-redux';
import { occupyChair } from '../../../store/Chairs/ChairsThunk';
import { useCallback } from 'react';
import { setJoinBy, setTargetChair } from '../../../../ProductivitySession/store/ProductivitySessionSlice';
import { setOpenModal } from '../../../../ControlPanel/store/controlPanelSlice';
import { addNotification } from '../../../../Notifications/store/notificationsSlice';
import { useTranslation } from 'react-i18next';
import { getConferenceUserParams } from '../../../../../utils/conferenceUtils';
import NotificationBuilder from '../../../../Notifications/utils/NotificationBuilder';

const Chair = ({ chair, chairBounds, mapRef, overlays, clickableRef }) => {


    const { localAvatar } = useSelector((state) => state.auth);
    const localAvatarRef = useRef(localAvatar);
    const { uiState,conference } = useSelector((state) => state.activeConference);
    const avatarsData = useSelector((state) => state.avatars?.avatars || {});
      const { t } = useTranslation();
    
    const dispatch = useDispatch();
    const {
        sessionView,
    } = useSelector((state) => state.productivitySession);

    const {
        chairs
    } = useSelector((state) => state.chairs);

    useEffect(() => {
        localAvatarRef.current = localAvatar;
    }, [localAvatar]);

    useEffect(() => {
    }, [clickableRef]);

    /*const safeParticipants = Array.isArray(conference.participants) && Array.isArray(conference.participants[0])
        ? conference.participants[0]
        : (conference.participants || []);

    const joinedParticipants = safeParticipants.filter(p => avatarsData[p.user_id]) 
        .map(p => {
            const avatar = avatarsData[p.user_id] || {};
            
            return {
                ...p,
                ...avatar,
                conference_user_id: p.id,
            };
        });
    let myUser = joinedParticipants.find(p => p.user_id === localAvatar?.id);
    const isAccessTypeRoom = is_conference_active && 
                    myUser?.role === "guest_externe" &&
                    myUser?.access_type === 'room';*/
    
    const { isAccessTypeRoom } = getConferenceUserParams(
        conference, 
        avatarsData, 
        localAvatar, 
        uiState.is_conference_active
    );

    const onChairClick = useCallback(() => {


        const currentAvatarChairId = localAvatarRef.current?.chair_id;
        const currentAvatarChair = chairs.find(c => c.id === currentAvatarChairId);
        const isSameRoom = currentAvatarChair && currentAvatarChair.room_id === chair.room_id;

        if (isSameRoom) {

            if (localAvatarRef.current?.chair_id !== chair.id && clickableRef.current) {
                dispatch(occupyChair({
                    body: {
                        currentChairId: localAvatarRef.current?.chair_id,
                        targetChairId: chair.id
                    }
                }));
            }
        }
        else {
            if(isAccessTypeRoom){
                const notification = NotificationBuilder.info()
                    .withHeader('cant_move', true)
                    .build();
                dispatch(addNotification(notification));
               
            }
            else{
                if (localAvatarRef.current?.chair_id !== chair.id && clickableRef.current && sessionView !== 'progress' && localAvatarRef.current?.focus_state === 0) {
                    dispatch(occupyChair({
                        body: {
                            currentChairId: localAvatarRef.current?.chair_id,
                            targetChairId: chair.id
                        }
                    }));
                }
                else if (localAvatarRef.current?.chair_id !== chair.id && clickableRef.current && sessionView === 'progress' && localAvatarRef.current?.focus_state === 1) {
                    dispatch(setJoinBy("chair"));
                    dispatch(setTargetChair(chair.id));
                    dispatch(setOpenModal("stop_focus"));
                }
            }
        }

    }, [chair.id, sessionView,isAccessTypeRoom]);

    const onCheckClickRef = useRef(onChairClick);

    useEffect(() => {
        onCheckClickRef.current = onChairClick;
    }, [onChairClick]);

    useEffect(() => {
        const overlayId = "chair-" + chair.id;

        if (!overlays.current[overlayId]) {

            const bounds = L.latLngBounds(
                [
                    chair.lat + chairBounds[0][0],
                    chair.lng - chairBounds[0][1],
                ],
                [
                    chair.lat - chairBounds[1][0],
                    chair.lng + chairBounds[1][1],
                ],
            );
            const html = `
          <div style="width: 100%; height: 100%;">
            <div class="user-avatar1" style="width: 100%; height: 100%;">
              <figure class="item-thumbnail user-avatar1">
                <img src="Avatar.png" alt="Avatar">
              </figure>
            </div>
          </div>`;

            overlays.current[overlayId] = new AvatarOverlay(
                html,
                bounds,
                {
                    className: "custom-avatar-class",
                    interactive: true,
                    opacity: 0,
                    chair_id: chair.id,
                },
            );
            overlays.current[overlayId].addTo(mapRef.current);
            const element = overlays.current[overlayId].getElement();
            element.style.zIndex = 301;

            element.addEventListener("mouseover", () => {
                element.style.opacity = 1;
                element.style.zIndex = 601;
            });
            element.addEventListener("mouseout", () => {
                element.style.opacity = 0;
                element.style.zIndex = 301;
            });

            element.addEventListener("click", () => {
                element.style.opacity = 0;
                element.style.zIndex = 301;
            });
            const onCheckClickRefProxy = () => {
                onCheckClickRef.current();
            }
            element.addEventListener("click", onCheckClickRefProxy);
        }

        return () => {
            if (overlays.current[overlayId]) {
                overlays.current[overlayId].remove();
                delete overlays.current[overlayId];
            }
        };

    }, []);

    return (
        <></>
    );
};

export default Chair;